import * as apiPasswordReminder from '@/api/my-link'

const myLink = {
  // plugins: [createPersistedState({ key: 'lc-app' })], // LocalStorageに保存する場合はコメント解除
  namespaced: true,
  state: {

  },
  getters: {
  },
  mutations: {
  },
  actions: {
  }
}

export default myLink
